module.exports = __webpack_public_path__ + "img/pic_sigit.fe40cb85.png";